
import { getField, updateField } from 'vuex-map-fields';
import { updateFamilyMembers} from '@/service/UsersService'

export default {
    namespaced: true,
    state: {
            id: "",
            name: "",
            surname: "",
            email: "",
            dob: "",
            relation: ""
    },
    mutations: {
        updateField,
        dump(state) {
            console.log(state);
        },
        updateId(state, id) {
            state.id = id;
        },
        updateName(state, name) {
            state.name = name;
        },
        updateSurname(state, surname) {
            state.surname = surname;
        },
        updateEmail(state, email) {
            state.email = email;
        },
        updateDob(state, dob) {
            if (typeof(dob) == "string" )
            {
                if (dob == "") dob = new Date();
                else {
                    dob = new Date(dob);
                } 
            }
            state.dob = dob;
        },
        updateRelation(state, relation) {
            state.relation = relation;
        },
        clear(state) {

            state.id = "";
            state.name = "";
            state.surname = "";
            state.email = "";
            state.dob = new Date();
            state.relation = "";
        }
    },
    actions: {
        load: async ({commit, rootGetters}, id) => {
            let familyMembers = rootGetters["profile/family_members"];
            let familyMember = familyMembers.find((familyMember) => familyMember.id == id);
            commit("updateId", familyMember.id);
            commit("updateName", familyMember.name);
            commit("updateSurname", familyMember.surname);
            commit("updateEmail", familyMember.email);
            commit("updateDob", familyMember.dob);
            commit("updateRelation", familyMember.relation);
        },
        remove({rootGetters, dispatch}, id) {
            let familyMembers = rootGetters["profile/family_members"];
            let userId = rootGetters["profile/id"];
            let accesstoken = rootGetters["userdata/getAccessToken"];
            let newFamily = familyMembers.filter((familyMember) => familyMember.id != id);
            return updateFamilyMembers(accesstoken, userId, newFamily).then((response) => {
                dispatch("profile/loadMe", {}, {root: true});
                return response;
            });

        },
        addFamilyMember: async ({rootGetters, state, dispatch, commit}) => {
            let family_member = {
                name: state.name,
                surname: state.surname,
                email: state.email,
                dob: state.dob,
                relation: state.relation
            }
           
            let familyMembers = rootGetters["profile/family_members"];
            let userId = rootGetters["profile/id"];
            let accesstoken = rootGetters["userdata/getAccessToken"];
            let newFamily = [...familyMembers, family_member];

            return updateFamilyMembers(accesstoken, userId, newFamily).then((response) => {

                dispatch("profile/loadMe", {}, {root: true});
                commit("clear");
                return response;
            });
        },
        updateFamilyMember: async ({rootGetters, state, dispatch}) => {
            let updated_family_member = {
                id: state.id,
                name: state.name,
                surname: state.surname,
                email: state.email,
                dob: state.dob,
                relation: state.relation
            }
           
            let familyMembers = rootGetters["profile/family_members"];
            let userId = rootGetters["profile/id"];
            let accesstoken = rootGetters["userdata/getAccessToken"];
            let newFamily = familyMembers.map((familyMember) => {
                if (familyMember.id == updated_family_member.id) {
                    return updated_family_member;
                }
                return familyMember;
            });

            return updateFamilyMembers(accesstoken, userId, newFamily).then((response) => {

                dispatch("profile/loadMe", {}, {root: true});
                
                return response;
            });
        },
    },
    getters: {
        // Add the `getField` getter to the
        // `getters` of your Vuex store instance.
        getField,
        id: state => state.id,
        name: state => state.name,
        surname: state => state.surname,
        email: state => state.email,
        dob: state => state.dob,
        relation: state => state.relation
      },

}